import { Stack, Typography } from '@mui/material';
import { HorizontalForm, CustomButton } from '../../../common/components';
import { formatCurrency } from '../../../utils/formatUtils';

const SummaryMetric = ({ label, value, highlight = false }) => (
  <Stack spacing={0.5} alignItems="flex-start">
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h6" fontWeight={700} color={highlight ? 'primary' : 'text.primary'}>
      {value}
    </Typography>
  </Stack>
);

const DebtNotificationsSummary = ({
  summary,
  selectedSummary,
  onClearSelection,
  onSendNotifications,
  disableClear,
  disableSend,
}) => {
  const totalRecords = summary?.total_records ?? 0;
  const totalCoupons = summary?.total_coupons ?? 0;
  const totalAmount = summary ? formatCurrency(summary.total_amount ?? 0) : formatCurrency(0);
  const selectedCoupons = selectedSummary.selectedCoupons ?? 0;
  const selectedRecipients = selectedSummary.selectedRecipients ?? 0;
  const selectedAmount = formatCurrency(selectedSummary.totalAmount ?? 0);

  return (
    <HorizontalForm justifyContent="space-between">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} alignItems={{ md: 'center' }}>
        <SummaryMetric label="Contratos filtrados" value={totalRecords} />
        <SummaryMetric label="Cupones filtrados" value={totalCoupons} />
        <SummaryMetric label="Monto total" value={totalAmount} highlight />
        <SummaryMetric label="Cupones seleccionados" value={selectedCoupons} />
        <SummaryMetric label="Suscriptores seleccionados" value={selectedRecipients} />
        <SummaryMetric label="Monto a notificar" value={selectedAmount} highlight />
      </Stack>

      <Stack direction="row" spacing={1}>
        <CustomButton
          variant="warning"
          onClick={onClearSelection}
          disabled={disableClear}
        >
          Limpiar selección
        </CustomButton>
        <CustomButton
          variant="danger"
          onClick={onSendNotifications}
          disabled={disableSend}
        >
          Enviar recordatorio
        </CustomButton>
      </Stack>
    </HorizontalForm>
  );
};

export default DebtNotificationsSummary;
